module.exports = __webpack_public_path__ + "img/part_tab3_box2_5.53f4bf47.jpg";